import { render, staticRenderFns } from "./platformOperation.vue?vue&type=template&id=b5836466&"
import script from "./platformOperation.vue?vue&type=script&lang=js&"
export * from "./platformOperation.vue?vue&type=script&lang=js&"
import style0 from "./platformOperation.vue?vue&type=style&index=0&id=b5836466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports